// 可复现随机源（EP-005-S1）—— 依赖注入式 rng，便于测试固定种子复现掉落。
//
// rng(seed)：Mulberry32，返回 () => number，区间 [0, 1)。
// randomRng()：生产环境用 Math.random 播种的实现（store / UI 调用，非 domain 层）。
export function rng(seed: number): () => number {
  let a = seed >>> 0;
  return function next(): number {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

// 生产环境随机源：用 Math.random 播种一个 Mulberry32 实例。
export function randomRng(): () => number {
  return rng(Math.floor(Math.random() * 0xffffffff));
}
